import {
  Box,
  Divider,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Stack,
  styled,
  Typography,
} from '@mui/material'
import { ArrowIOSIcon } from '$common/icons/arrow-ios'

const Root = styled(Stack)`
  width: calc(50% - 6px);
`

const StyledStack = styled(Stack)`
  border-radius: 0 0 8px 8px;
`

const TitleBox = styled(Box)`
  height: 44px;
  border-radius: 8px 8px 0 0;
  display: flex;
  justify-content: center;
  align-items: center;
`

const StyledListItemIcon = styled(ListItemIcon)`
  min-width: 20px;
`

const StyledListItemText = styled(ListItemText)(({ theme }) => ({
  '.MuiTypography-root': {
    ...theme.typography.body2,
    lineHeight: '20px',
    color: theme.palette.gray,
  },
}))

const ListItem = styled(ListItemButton)(({ theme }) => ({
  height: '52px',
  backgroundColor: theme.palette.white,
  '&:hover': {
    backgroundColor: theme.palette.white,
  },
  padding: '0 12px',
}))

interface Props {
  title: string
  titleSx: Record<string, unknown>
  borderColor: string
  items: { title: string; onClick: () => unknown }[]
}

export function ListBox({ title, titleSx, borderColor, items }: Props) {
  return (
    <Root>
      <TitleBox sx={{ ...titleSx }}>
        <Typography color="white" variant="subtitle3">
          {title}
        </Typography>
      </TitleBox>
      <StyledStack
        sx={{ border: `1px solid ${borderColor}`, overflow: 'hidden' }}
      >
        {items.map((item, index) => (
          <>
            <ListItem onClick={item.onClick}>
              <StyledListItemText>{item.title}</StyledListItemText>
              <StyledListItemIcon>
                <ArrowIOSIcon
                  sx={{ color: 'semiLightGray', width: '20px', height: '20px' }}
                />
              </StyledListItemIcon>
            </ListItem>
            {index + 1 !== items.length && <Divider />}
          </>
        ))}
      </StyledStack>
    </Root>
  )
}
